import { post, get, baseURL } from "@/utils/request";

export const updateUnreadMessage = (data: any) => post(`/notification/markAsRead`, data);

export const getMessageList = (params: any) => post(`/notification/notificationList?pageNum=${params.pageNum}&pageSize=${params.pageSize}&orderByColumn=id&isAsc=desc`, {type : params.type});

export const getUnreadMessageList = (params: any) => post(`/notification/unreadNotificationList?pageNum=1&pageSize=${params.pageSize}&orderByColumn=id&isAsc=desc`);
